<template>
  <div class="container" style="padding: 30px 0">
    <div class="row" v-if="success">
      <div class="col my-4 text-center">
        <h3 class="p5 my-5">Gracias por reservar</h3>
        <router-link to="/">Volver al inicio</router-link>
      </div>
    </div>
    <div class="row" v-if="!success">
      <div class="col-12">
        <h1 class="text-center">Pedidos</h1>
        <hr />
      </div>

      <div class="col-12" style="margin-bottom: 30px">
        <div class="row">
          <div class="col-12">
            <h5 class="text-center" style="padding: 30px">Sucursal?</h5>
          </div>
          <div class="col">
            <!-- <router-link
              to="/chiguayante"
              class="btn btn-outline-danger btn-block"
            >
              Chiguayante
            </router-link> -->
             <!-- <button
              type="button"
              class="btn btn-outline-danger btn-block"
              data-toggle="modal"
              data-target="#exampleModal"
              data-whatever="@mdo"
              @click="showPage('chiguayante')"
            >
              Chiguayante
            </button> -->
            <a target="_blank" href="https://chiguayante.eiensushi.cl" class="btn btn-outline-danger btn-block">
              Chiguayante
            </a>
          </div>

          <div class="col" v-if="false">
            <!-- <router-link to="/hualpen" class="btn btn-outline-danger btn-block">
              Hualpen
            </router-link> -->
            <button
              type="button"
              class="btn btn-outline-danger btn-block"
              data-toggle="modal"
              data-target="#exampleModal"
              data-whatever="@mdo"
              @click="showPage('hualpen')"
            >
              Hualpen
            </button>
            <!-- @click="showPage('/eiensushihualpen')"
              class="btn btn-outline-danger btn-block"
            >
              Hualpen
            </button> -->
          </div>

          <div class="col d-none">
            <!-- <router-link
              to="/concepcion"
              class="btn btn-outline-danger btn-block"
            >
              Concepcion
            </router-link> -->
             <button
              type="button"
              class="btn btn-outline-danger btn-block"
              data-toggle="modal"
              data-target="#exampleModal"
              data-whatever="@mdo"
              @click="showPage('concepcion')"
            >
              Concepcion
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="exampleModal"
      
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      style="z-index: 999px"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content" style="height: 90vh;">
          <div class="modal-header">
            <h5 class="modal-title">Pedidos</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="w-100">
              <div class="alert alert-info mb-0">
                Si tienes problemas para navegar, te recomendamos <a :href="url" target="_blank">abrir en una nueva pestaña</a>
              </div>
            </div>
            <div class="embed-responsive" style="height: 100%">
              <iframe
                class="embed-responsive-item"
                :src="url"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div class="modal-footer d-none">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Salir
            </button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Reservas",
  data() {
    return {
      url: "",
      loading: false,
      success: false,
      retiro: false,
      reparto: false,
      mesa: false,
      promocion_selected: null,
      tipo: null,
      notas: "",
      nombre: "",
      direccion: "",
      telefono: "",
      medio_pago: null,
      personas: 1,
      correo: "",
      fecha: null,
      hora: null,
      local: null,
      medio_pago: null,
      efectivo: "Con lo justo",
      data_reparto: {
        name: null,
      },
      promociones: [
        {
          name: "Promocion #1 26 piezas",
          value: 7990,
          id: "p1",
          selected: [],
          options: [
            {
              name: "Cobertura frita",
              values: ["Panko", "Tempura"],
            },
            {
              name: "Cobertura fria",
              values: ["Palta", "Sesamo"],
            },
          ],
        },
        {
          name: "Promocion #2 44 piezas",
          value: 10990,
          id: "p2",
          selected: [],
          options: [
            {
              name: "Cobertura fria",
              values: ["Palta", "Salmon"],
            },
          ],
        },
        {
          name: "Promocion #3 56 piezas",
          value: 13990,
          id: "p3",
          selected: [],
          options: [
            {
              name: "Cobertura fria",
              values: ["Palta", "Salmon"],
            },
          ],
        },
        {
          name: "Promocion #4 32 piezas picantes",
          value: 9990,
          id: "p4",
          selected: [],
          options: [
            {
              name: "Adereso del Super snow roll",
              values: ["Sesamo", "Mani", "Merken", "Ciboulette"],
            },
          ],
        },
      ],
    };
  },
  methods: {
    showPage(url) {
      //this.$refs["modal-page"].show();
      this.url = `https://${url}.eiensushi.cl`;
    },
    setReparto() {
      this.reparto = true;
      this.retiro = false;
      this.mesa = false;
    },
    setRetiro() {
      this.retiro = true;
      this.reparto = false;
      this.mesa = false;
    },
    setMesa() {
      this.mesa = true;
      this.reparto = false;
      this.retiro = false;
    },
    sendDelivery() {
      const data = {
        local: this.local,
        promo: this.promocion_selected,
        nombre: this.nombre,
        tipo: this.tipo,
        direccion: this.direccion,
        telefono: this.telefono,
        medio_pago: this.medio_pago,
        efectivo: this.efectivo,
        notas: this.notas,
      };
      this.loading = true;
      this.$http
        .post("http://api.eiensushi.cl/delivery", data)
        .then((res) => {
          alert(
            "Reserva realizada correctamente, se confirmara por llamada cuando este aprobada"
          );
          this.success = true;
          this.loading = false;
        })
        .catch((err) => {
          console.log("Error", err);
          this.loading = false;
          alert("Error al enviar los datos verifique e intente nuevamente");
        });
    },
    sendReserva() {
      const data = {
        nombre: this.nombre,
        correo: this.correo,
        fecha: this.fecha,
        telefono: this.telefono,
        hora: this.hora,
        personas: this.personas,
        notas: this.notas,
      };
      this.loading = true;
      this.$http
        .post("http://api.eiensushi.cl/reserva", data)
        .then((res) => {
          alert(
            "Reserva realizada correctamente, se confirmara por llamada cuando este aprobada"
          );
          this.success = true;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log("Error", err);
          alert("Error al enviar los datos verifique e intente nuevamente");
        });
    },
  },
  computed: {
    validateDelivery() {
      if (
        this.nombre == "" ||
        this.tipo == null ||
        this.telefono == "" ||
        this.medio_pago == null ||
        this.local == null ||
        this.promocion_selected == null
      )
        return true;
      return false;
    },
    validateReserva() {
      if (
        this.nombre == null ||
        this.telefono == "" ||
        this.fecha == null ||
        this.hora == null ||
        this.personas < 1 ||
        this.personas > 4 ||
        this.correo.indexOf("@") == -1
      )
        return true;
      return false;
    },
  },
};
</script>
